<template>
  <el-dialog
    title="编辑资料"
    :visible.sync="setInfoDialogFormVisible"
    :show="show"
    :modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form :model="creatFrom" ref="creatFrom" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="名称"
            :label-width="formLabelWidth"
            prop="platformTitle"
          >
            <el-input
              v-model="creatFrom.platformTitle"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="部署域名"
            :label-width="formLabelWidth"
            prop="url"
          >
            <el-input v-model="creatFrom.url" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="登录页背景图:"
            :label-width="formLabelWidth"
            prop="backgroundImage"
          >
            <el-upload
              ref="background"
              action=""
              :limit="1"
              :auto-upload="false"
              :on-remove="removeFile"
              :on-change="getLocalImg"
            >
              <div class="logo_upload_xuan">
                <i slot="default" class="el-icon-circle-plus-outline"></i>
                <span>选择图片</span>
              </div>
            </el-upload>
            <div class="logo_img">
              <div v-if="isHidden" class="logo_img_title"></div>
              <img v-else :src="backgroundUrl" class="background" />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="LOGO图片:"
            :label-width="formLabelWidth"
            prop="platformLogo"
            ><el-upload
              ref="Logo"
              action=""
              :limit="1"
              :auto-upload="false"
              :on-remove="removeLogo"
              :on-change="getLogoImg"
            >
              <div class="logo_upload_xuan">
                <i slot="default" class="el-icon-circle-plus-outline"></i>
                <span>选择图片</span>
              </div>
            </el-upload>
            <div class="logo_img">
              <div v-if="logoHidden" class="logo_img_title"></div>
              <img v-else :src="logoUrl" class="logo" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: center">
        <el-button type="primary" @click="save('creatFrom')"
          >确认保存</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import "../../../assets/css/dialog.css";
export default {
  name: "setInfoDialog",
  data() {
    return {
      defaultInfo: null,
      fd: new FormData(),
      logoUrl: "",
      backgroundUrl: "",
      logoHidden: true,
      isHidden: true,
      formLabelWidth: "120px",
      setInfoDialogFormVisible: null,
      creatFrom: {
        platformTitle: null,
        url: null,
      },
      rules: {
        platformTitle: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultId: String,
  },
  watch: {
    show() {
      const that = this;
      if (this.setInfoDialogFormVisible === false) {
        this.$refs.creatFrom.resetFields();
        this.$refs.background.clearFiles();
        this.$refs.Logo.clearFiles();
        this.backgroundUrl = "";
        this.logoUrl = "";
        this.isHidden = true;
        this.logoHidden = true;
        this.fd = new FormData();
      } else {
        if (this.defaultId === "new") {
          this.backgroundUrl = "";
          this.logoUrl = "";
          this.isHidden = true;
          this.logoHidden = true;
          this.fd = new FormData();
        } else {
          this.$http
            .get("/locationbs/platform/metadata?id=" + this.defaultId)
            .then((data) => {
              if (data.code === 200) {
                this.backgroundUrl = data.data.pag[0].backgroundImageUrl;
                this.logoUrl = data.data.pag[0].platformLogo;
                this.creatFrom.platformTitle = data.data.pag[0].platformTitle;
                this.creatFrom.url = data.data.pag[0].url;
                this.isHidden = false;
                this.logoHidden = false;
                let backgroundImgType =
                  data.data.pag[0].backgroundImageUrl.substring(
                    data.data.pag[0].backgroundImageUrl.lastIndexOf("."),
                    data.data.pag[0].backgroundImageUrl.length
                  );
                let logoImgType = data.data.pag[0].platformLogo.substring(
                  data.data.pag[0].platformLogo.lastIndexOf("."),
                  data.data.pag[0].platformLogo.length
                );
                if (
                  data.data.pag[0].backgroundImageUrl !== null &&
                  data.data.pag[0].backgroundImageUrl !== ""
                ) {
                  this.getImageFileFromUrl(
                    data.data.pag[0].backgroundImageUrl,
                    "background" + backgroundImgType
                  ).then((file) => {
                    that.fd.append("backgroundImage", file);
                  });
                }
                if (
                  data.data.pag[0].platformLogo !== null &&
                  data.data.pag[0].platformLogo !== ""
                ) {
                  this.getImageFileFromUrl(
                    data.data.pag[0].platformLogo,
                    "logo" + logoImgType
                  ).then((file) => {
                    that.fd.append("platformLogo", file);
                  });
                }
              }
            });
        }
      }
      this.setInfoDialogFormVisible = this.show;
    },
  },
  methods: {
    getImageFileFromUrl(filePath, fileName) {
      return new Promise((resolve, reject) => {
        let blob = null;
        let xhr = new XMLHttpRequest();
        xhr.open("GET", filePath);
        // 这里设置接收的响应体类型(试了不设置也正常)
        xhr.setRequestHeader(
          "Accept",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        xhr.responseType = "blob";
        // 加载时处理(异步)
        xhr.onload = () => {
          // 获取返回结果
          blob = xhr.response;
          let file = new File([blob], fileName, { type: blob.type });
          // 返回结果
          resolve(file);
        };
        xhr.onerror = (e) => {
          reject(e);
        };
        // 发送
        xhr.send();
      });
    },
    removeFile() {
      this.fd.delete("backgroundImage");
      this.backgroundUrl = "";
      this.isHidden = true;
    },
    removeLogo() {
      this.fd.delete("platformLogo");
      this.logoUrl = "";
      this.logoHidden = true;
    },
    getLocalImg(event) {
      if (this.fd.get("backgroundImage")) {
        this.fd.set("backgroundImage", event.raw);
      } else {
        this.fd.append("backgroundImage", event.raw);
      }
      // 获取上传图片的本地url，用于上传前的本地预览
      let url = "";
      if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(event.raw);
      } else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(event.raw);
      } else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(event.raw);
      }
      this.backgroundUrl = url;
      this.isHidden = false;
    },
    getLogoImg(event) {
      if (this.fd.get("platformLogo")) {
        this.fd.set("platformLogo", event.raw);
      } else {
        this.fd.append("platformLogo", event.raw);
      }
      // 获取上传图片的本地url，用于上传前的本地预览
      let url = "";
      if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(event.raw);
      } else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(event.raw);
      } else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(event.raw);
      }
      this.logoUrl = url;
      this.logoHidden = false;
    },
    save(name) {
      const that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          let url;
          if (that.defaultId === "new") {
            url = "/locationbs/platform/addPlatform?";
          } else {
            url =
              "/locationbs/platform/updatePlatform?id=" + that.defaultId + "&";
          }
          that.$http
            .post(
              url +
                "url=" +
                that.creatFrom.url +
                "&platformTitle=" +
                that.creatFrom.platformTitle,
              that.fd
            )
            .then((data) => {
              console.log(data);
              if (data.code === 200) {
                that.$message({
                  message: "操作成功！",
                  type: "success",
                });
                that.setInfoDialogFormVisible = false;
                that.$parent.getPlatformList();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.background {
  width: 250px;
  display: block;
}
.logo {
  width: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/platformDialogDir/setInfoDialog.vue